export default {
  首页: "Hogar",
  资产: "Activos",
  币币: "Divisa",
  快捷买币: "Comercio P2P",
  "支持多种方式购买，购买更简单":
    "Admite múltiples formas de comprar, compra más simple",
  语言设置: "Ajustes de idioma",
  确认恢复: "Confirmar recuperación",
  "输入邮箱，方便我们联系您":
    "Ingresa tu correo electrónico para que podamos contactarte",
  划转: "Transferir",
  行情: "Cotizaciones",
  "24H成交": "transacción 24H",
  累计收益: "Ingreso acumulado",
  充值时间: "Tiempo de recarga",
  到期时间: "Fecha de caducidad",
  数量: "Cantidad",
  操作: "Funcionar",
  资产信息: "Información de activos",
  复制地址: "Copiar",
  链名称: "Nombre de la cadena",
  充值地址: "dirección de recarga",
  收款地址: "Dirección de Pago",
  账单: "Factura",
  提现金额: "Cantidad de retiro",
  接收地址: "Dirección de recepción",
  交易密码: "Contraseña de transacción",
  提现全部: "retirar todo",
  保存图片: "Guardar imagen",
  输入您的交易密码: "Contraseña de transacción",
  确定: "Por supuesto",
  地址: "Dirección",
  注册时间: "hora de firmar",
  取消: "Cancelar",
  是否划转: "Ya sea para transferir",
  登录: "Iniciar sesión",
  我的地址: "Mi dirección",
  登录密码和交易密码:
    "Contraseña de inicio de sesión y contraseña de transacción",
  注册: "Registro",
  密码: "Clave",
  设置密码: "Configurar la clave",
  重复密码: "Repita la contraseña",
  新密码: "Nueva contraseña",
  确认新密码: "Confirmar la nueva contraseña",
  充值: "Recargar",
  充值货币: "Recargar",
  合约账户充值: "Recarga de cuenta de futuros",
  账户充值: "recarga de cuenta",
  其他: "Otro",
  我的邀请码: "Código de invitación",
  提现: "Retirar",
  客服: "Cliente",
  持有详情: "detalles de tenencia",
  请输入内容: "Por favor ingrese el contenido",
  邀请好友来领取奖励: "Invita a tus amigos a recibir recompensas",
  复制链接: "Copiar",
  重复设置新的密码: "Repita la configuración de una nueva contraseña",
  保存: "Ahorrar",
  我的: "Mío",
  "邮箱/手机号": "Correo electrónico/Número de móvil",
  备注: "Observación",
  地址管理: "Mi dirección",
  我的团队: "equipos",
  联系我们: "Contáctenos",
  竭诚为您服务: "Atentamente a su servicio",
  提取收益: "ingresos por retiro",
  带给我的收益: "mi beneficio",
  添加: "Agregar",
  名称: "Nombre",
  添加地址: "Añadir dirección",
  修改地址: "Cambiar dirección",
  可提现: "se puede retirar",
  安全中心: "Centro de Seguridad",
  收益划转: "transferencia de ingresos",
  通知中心: "Notificación",
  "累计收益:": "Ganancias Acumulativas:",
  注册用户: "Usuario registrado",
  奖励规则: "Reglas de recompensa",
  帮助反馈: "comentarios de ayuda",
  邀请好友: "Invitar a amigos",
  恢复身份: "Restaurar identidad",
  选择语言: "Elige lengua",
  设置新的密码: "Establecer nueva contraseña",
  暂无活动: "Ninguna actividad",
  "月增长量(+)": "Crecimiento Mensual (+)",
  可提取: "Extraíble",
  反馈类型: "Tipo de Comentarios",
  赠送: "Donar",
  已经复制: "copiado",
  保存成功: "Guardado con éxito",
  划转成功: "Transferencia exitosa",
  过期: "Venció",
  提交成功: "Enviado satisfactoriamente",
  "服务器繁忙，稍后在试": "El servidor está ocupado, intentándolo más tarde",
  全部: "Todos",
  一级: "Nivel 1",
  二级: "Nivel 2",
  三级: "Nivel 3",
  级: "Clase",
  删除成功: "Eliminado con éxito",
  选择地址: "Elige la dirección",
  不再提醒: "Sin recordatorios",
  "最小充值金额：": "Recarga mínima:",
  选择币种: "Seleccione el tipo de moneda",
  输入投资金额: "Monto de la inversión",
  输入账户密码: "Clave",
  投资: "Invertir",
  订单编号: "Solicitar ID",
  投资周期: "Ciclo",
  投资资金: "Fondos",
  投资时间: "Tiempo",
  状态: "Estado",
  投资中: "invertir",
  已到期: "Venció",
  暂无数据: "Sin datos",
  转入: "Transferencia",
  邮箱: "Correo",
  请输入邮箱: "Correo electrónico",
  请输入格式正确的邮箱: "Dirección de correo electrónico",
  请输入验证码: "Código de verificación",
  获取验证码: "Obtener código",
  请输入邀请码: "Código de invitación",
  今天: "Este Dia",
  昨天: "El dia de ayer",
  最近七天: "últimos siete días",
  邀请: "Invitar",
  购买数量: "Cantidad de compra",
  产品详情: "Detalles de producto",
  币种: "Divisa",
  利息币种: "Moneda de interés",
  理财类型: "tipo financiero",
  产品费率: "Tarifa de producto",
  进行中: "Procesando",
  每天: "Todos los días",
  请输入搜索关键词: "Por favor busque palabra clave",
  通知: "Aviso",
  查看更多: "Más",
  理财宝: "HODL y ganar",
  周期: "Ciclo",
  年利率: "ABR",
  更多产品: "Más productos",
  灵活存取: "Depósitos Flexibles",
  稳定收益: "Rendimientos estables",
  合约指南: "Guía",
  资金划转出: "Transferencia de fondos",
  矿池收益: "Ingresos del grupo minero",
  提现手续费: "Cargo por retiro",
  冻结资金: "congelar fondos",
  解冻资金: "Descongelar fondos",
  闪兑支出: "gasto relámpago",
  闪兑收入: "Ingresos de Canjear",
  闪兑手续费: "Tarifa de Canjear",
  合约支出: "Gastos de futuros",
  合约收入: "Ingresos de futuros",
  输入的金额不可大于可用金额:
    "La cantidad ingresada no puede ser mayor que la cantidad disponible",
  全部兑换成功: "Exitosamente",
  返回: "Devolver",
  查看历史: "Ver historial",
  闪兑历史: "Historial de destellos",
  支付: "Pagar",
  获取: "Obtener",
  时间: "Tiempo",
  手续费: "Tasa de tramitación",
  折扣: "Descuento",
  价格: "Precio",
  逐仓: "Aislado",
  全仓: "Cruz",
  市价委托: "orden de mercado",
  限价委托: "orden limitada",
  请输入本金: "Monto",
  请输入价格: "Precio",
  "可做空/做多": "Corto largo",
  设置止盈止损: "TP/SL",
  止盈价: "Est. TP",
  止损价: "Est. SL",
  成本: "Costo",
  做多: "Largo",
  做空: "Corto",
  仓位信息: "Información de posición",
  一键平仓: "Cierra todo",
  永续: "",
  浮动盈亏: "P&L",
  平仓: "Cerca",
  反向开仓: "RVS abierto",
  一键撤销: "Deshacer con un clic",
  倍杠杆: "x",
  执行价格: "Precio de ejercicio",
  委托数量: "Numero de ordenes",
  保证金: "Margen",
  成交价: "Precio de apertura",
  创建时间: "Fecha de Creación",
  撤销: "Revocar",
  合约市场: "mercado de futuros",
  交易方向: "dirección comercial",
  委托价格: "Precio del pedido",
  委托金额: "monto de la comisión",
  资金费率: "Tasa de financiación",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Una tarifa recurrente pagada por operadores largos y cortos, liquidada cada 8 horas.",
  "资金费率为正，多方向空方支付资金费用。":
    "La tasa de fondeo es positiva y el lado largo paga al lado corto la tarifa de fondeo.",
  "资金费率为负，空方向多方支付资金费用。":
    "La tasa de financiación es negativa y el lado corto paga la tarifa de financiación a las múltiples partes.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "¿Está seguro de que desea abrir una posición al revés? La posición de apertura inversa se comprará con la posición opuesta actual",
  "仓位止盈/止损": "Posición Take Profit/Stop Loss",
  合约名称: "Futuros",
  开仓价格: "Abrir un puesto",
  指数价格: "Precio índice",
  止盈设置: "Configuración de toma de ganancias",
  请输入止盈价: "Ingrese el precio de toma de ganancias",
  "当指数价格触达*时，将会触发委托平仓":
    "Cuando el precio del índice toca {0}, activará la orden para cerrar la posición.",
  预计盈亏: "Cantidad de liquidación",
  当前仓位: "Posición actual",
  平仓金额: "cantidad de liquidación",
  仓位模式: "Modo de posición",
  全仓模式: "Modo de almacén completo",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Todos los fondos disponibles en la cuenta de futuros se consideran margen disponible. Cuando la pérdida de la posición exceda el saldo de la cuenta, la posición se liquidará y todo el margen y la posición se perderán. Tenga en cuenta que",
  逐仓模式: "Modo de margen aislado",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Hará que una cierta cantidad de margen en la cuenta de futuros se asigne a la posición. Si la pérdida del margen cae por debajo del nivel del margen de mantenimiento, se liquida esa posición. En el modo de posición aislada, puede aumentar y disminuir el margen de esta posición.",
  "是否撤销？": "¿Está revocado?",
  "是否一键撤销？": "¿Es deshacer con un clic?",
  "是否一键平仓？": "Ya sea para cerrar una posición con un clic?",
  持仓保证金: "Margen de posición",
  风险率: "Riesgo",
  未实现盈亏: "P&L",
  可用保证金: "Margen libre",
  净值: "nuevo valor",
  账户余额: "Balance",
  合约计算器: "Calculadora",
  交易记录: "Registro de la transacción",
  "*倍杠杆": "{num} x",
  "平仓盈亏：": "PyG de cierre:",
  时间筛选: "Filtro de tiempo",
  仓位类型: "Tipo de Posición",
  订单状态: "Estado del pedido",
  订单类型: "Tipo de orden",
  平仓价格: "Precio de cierre",
  持仓数量: "Cantidad",
  "手续费(%)": "Tasa de tramitación (%)",
  平仓时间: "hora de cierre",
  平仓类型: "Tipo de cierre",
  手动平仓: "Cerrar una posición manualmente",
  强制平仓: "liquidación forzosa",
  近1天: "1 día",
  近7天: "7 días",
  近30天: "30 dias",
  近180天: "180 días",
  持仓: "Posición",
  已取消: "Cancelado",
  分时: "Tiempo",
  "24H额(USDT)": "Cantidad de 24 horas (USDT)",
  "24H低": "24H bajo",
  "24H量(BTC)": "Volumen 24H (BTC)",
  "24H高": "24H alto",
  "10秒": "10 segundos",
  "30秒": "30 segundos",
  "1分": "1 punto",
  "3分": "3 puntos",
  "5分": "5 puntos",
  "30分": "30 puntos",
  "1小时": "1 hora",
  "4小时": "4 horas",
  "8小时": "8 horas",
  "1天": "1 día",
  "1周": "1 semana",
  "1月": "enero",
  单向持仓: "Posición unidireccional",
  杠杆: "palanca",
  仓位: "Posición",
  计算结果: "Resultados de cálculo",
  盈亏: "Ganancia y perdida",
  收益率: "Tasa de retorno",
  计算结果仅供参考: "Los resultados del cálculo son solo para referencia.",
  成交后仓位大小: "Tamaño de la posición después de la transacción",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Los resultados del cálculo son solo de referencia, los resultados reales pueden variar debido a las diferencias de tarifas",
  目标价格: "Objetivo",
  开始计算: "Empezar a calcular",
  强平价格: "Liquidación",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Antes de recargar, verifique cuidadosamente el nombre de la cadena de recarga. Si la recarga es incorrecta, los activos no se pueden recuperar. {0}La cantidad mínima de recarga es {1}; si el monto es menor a este monto, la plataforma no podrá confirmar el recibo. No recargue activos que no sean {2} a esta dirección, de lo contrario no será posible. Para recuperar los activos, no extraiga la dirección de crowdfunding o ICO directamente, la plataforma no actuará como un proxy para la emisión de tokens.",
  "最小输入*": "Mínimo {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "El monto mínimo de retiro es {0}, la tarifa de retiro se deducirá de su monto de retiro. Antes de retirar monedas, confirme y verifique la dirección de recepción, y no retire {1}a una dirección que no sea {2}, de lo contrario, los activos no se recuperarán. No retire la dirección de crowdfunding o ICO directamente, la plataforma no manejará la emisión de tokens.",
  退出登录: "desconectar",
  加仓: "Agregar",
  新增仓位: "Agregar",
  输入加仓金额: "Introduce la cantidad",
  "当前可用:": "Actualmente disponible:",
  资产账单: "Factura de activos",
  保存二维码: "Descarga",
  温馨提示: "Consejos amables",
  "请注意：您当前使用的网络": "Nota: Su red actual",
  输入提现地址: "Ingrese la dirección de retiro",
  "可用金额：": "Cantidad disponible:",
  输入资产密码: "Contraseña de activo",
  可用手续费: "Tarifa de manejo disponible",
  "折扣%": "Descuento%",
  实扣手续费: "Tarifa de deducción real",
  实际到账: "Crédito real",
  未设置资产密码: "Contraseña de recurso no establecida",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Para la seguridad de sus activos, configure la contraseña del activo antes de retirar.",
  热榜: "Caliente",
  涨幅榜: "Elevar",
  跌幅榜: "Perdedor",
  成交额榜: "Rotación",
  关于我们: "Sobre nosotros",
  登录密码: "Contraseña de inicio de sesión",
  设置: "Configurar",
  资产密码: "Contraseña de activo",
  修改登录密码: "Modificar contraseña de inicio de sesión",
  原密码: "Contraseña anterior",
  请输入新密码: "Nueva contraseña",
  请输入原密码: "Contraseña original",
  确认密码: "Confirmar contraseña",
  确定修改: "Aceptar para modificar",
  修改资产密码: "Modificar contraseña de activo",
  验证码: "Código de verificación",
  资产密码使用提示: "Consejos para usar la contraseña de activos",
  "资产密码用于转移、提取资产和交易。":
    "La contraseña del activo se utiliza para transferir, retirar activos y comerciar.",
  "创建与登录密码不同的资产密码。":
    "Cree una contraseña de activo diferente a la contraseña de inicio de sesión.",
  "定期更改您的资产密码。": "Cambie la contraseña de su activo regularmente.",
  提币历史: "Historial de retiros",
  "金额/余额": "Importe/Saldo",
  "手续费/折扣": "Tasa de tramitación/descuento",
  自选: "Opcional",
  现货: "Lugar",
  市价: "Precio de mercado",
  止损设置: "Ajuste de stop loss",
  合约K线图: "Gráfico de líneas K de futuros",
  "24H量": "Volumen 24H",
  "24H额": "cantidad 24H",
  合作指南: "Guía de Cooperación",
  盈亏计算: "PyG",
  当前可用: "Actualmente disponible",
  请输入加仓金额: "Por favor ingrese el monto del aumento",
  请重新输入加仓金额: "Vuelva a introducir el importe del aumento",
  平仓数量: "Número de cerrado",
  欢迎登录: "Ingresa, por favor",
  "忘记密码?": "¿Se te olvidó tu contraseña?",
  "还没有账号？": "¿Aún no tienes una cuenta?",
  立即注册: "Regístrate ahora",
  繁體中文: "Chino tradicional",
  找回密码: "Recuperar Contraseña",
  下一步: "Próximo paso",
  注册账户: "Registrar Cuenta",
  "请输入邀请码(选填)": "Código de invitación (opcional)",
  谢邀豪礼: "Invitación",
  "24小时邀请好友排名": "Clasificación de 24 horas para invitar a amigos.",
  "*人": "{0}",
  "差*人": "{0}brecha",
  "已超过10万人，每月轻松赚钱":
    "Tiene más de 100.000 personas, ganando dinero fácilmente cada mes.",
  最高: "más alto",
  邀请链接: "Enlace",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "La plataforma y tú comparten las comisiones generadas por tus amigos en la plataforma (spotutures, apalancamiento, flash exchange)",
  平台和您一起分享手续费: "Comparte la tarifa juntos",
  "*级": "{0}nivel",
  规则: "Regla",
  我的好友: "Amigos",
  好友详情: "Detalles del amigo",
  获得好友佣金方案: "Obtener programa de comisión de amigos",
  我的等级: "Mi nivel",
  我的邀请数据: "Mis datos de invitación",
  当前等级: "Nivel actual",
  平台奖励您: "La plataforma te premia",
  最高可获取平台奖励: "Recompensa máxima disponible",
  邀请规则: "Reglas de invitación",
  "邀请*级有效好友": "Invitar a amigos válidos de nivel {0}",
  好友等级: "Nivel de amigo",
  人: "Gente",
  奖金派送: "entrega de bonificación",
  平台奖励: "Recompensa de la plataforma",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "El derecho de interpretación final pertenece a la plataforma. Si se descubre que las recompensas de la plataforma se obtienen de manera anormal, se deducirán todas las recompensas, se congelará la cuenta y no se recuperarán esos activos.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Su cuenta debe ser una cuenta válida, y la plataforma determina que la condición de cuenta válida es (la cuenta se recarga en cualquier moneda) el valor mínimo de {0} USDT.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Los amigos que invite deben ser subordinados válidos. La plataforma determina que los subordinados válidos son (recarga de cuenta en cualquier moneda) valor mínimo de {0} USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Las cuentas del que invita y del invitado no pueden pertenecer a la misma IP.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "El nivel VIP se evalúa por la cantidad de amigos de alto nivel que invitas.",
  佣金成分: "Componente de comisión",
  收益统计: "Estadísticas de ingresos",
  昨日收益: "de ayer",
  月收益: "Mensual",
  获取收益: "Ingreso",
  "总收益：": "Total:",
  "*级好友": "{0}amigo de nivel",
  理财购买: "compra financiera",
  期限: "El término",
  可用金额: "Cantidad disponible",
  预估收益: "Ganancias estimadas",
  申购上限: "límite de suscripción",
  项目剩余: "Proyecto restante",
  "买入后预计*(SGT)开始计算收益。": "Espere que {0}(SGT) comience a ganar.",
  计息日: "Fecha de interés",
  申购日: "fecha de compra",
  到账日: "Fecha de llegada",
  到期自动续投: "Renovación automática después del vencimiento",
  申购: "Suscripción",
  搜索理财项目: "Buscar programas financieros",
  超高年化随心选: "Libre elección",
  "自由选择理财币种，稳定超额收益":
    "Libre elección de la moneda de gestión patrimonial para estabilizar el exceso de rentabilidad",
  理财总资产: "cantidad de compra",
  累计收益: "Ingreso acumulado",
  申购数量: "",
  立即购买: "Comprar ahora",
  年化收益率: "ABR",
  理财订单: "Orden financiero",
  持有: "Mantener",
  申购份额: "cuota de suscripción",
  到账日期: "Fecha de llegada",
  申购成功: "La suscripción es exitosa",
  到期: "Madurez",
  是否选择做多: "¿Eliges hacer más",
  "可用余额为0 不能操作": "El saldo disponible es 0 y no se puede operar",
  福利中心: "regalos",
  奖励记录: "Registro",
  我获取到的奖励: "recompensas que obtuve",
  总价值: "Valor total",
  新手任务: "tarea de principiante",
  身份认证: "Autenticación",
  身份验证: "Autenticación",
  去验证: "Para verificar",
  审核中: "Bajo revisión",
  已验证: "Verificado",
  认证失败: "Autenticación fallida",
  基础认证: "Certificación Básica",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Tenga en cuenta que la información de autenticación no se puede modificar una vez verificada, asegúrese de completar la información correcta",
  "国家/地区": "País / región",
  请选择: "Por favor elige",
  证件类型: "Tipo de certificado",
  证件编码: "Codificación",
  身份证: "tarjeta de identificación",
  护照: "Pasaporte",
  驾驶证: "Licencia de conducir",
  请输入编码: "Por favor ingrese el código",
  名字: "Nombre",
  请输入: "Por favor escribe",
  中间名: "Segundo nombre",
  选填: "Opcional",
  姓氏: "apellido",
  中国: "Porcelana",
  身份上传: "Carga de identidad",
  上传身份证: "Cargar identificación",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Los materiales anteriores deben cargarse en JPG/JPEG/PNormat y asegurarse de que los bordes y esquinas claros de la foto estén completos y el brillo sea uniforme. Y el tamaño no supera los {0}M.",
  确定提交: "Confirmar envío",
  去认证: "Certificación",
  挑战任务: "Misión de desafío",
  注册认证任务: "Regístrese para las tareas de certificación",
  完成注册认证即可领取:
    "Después de completar la certificación de registro, puede recibirla",
  领取奖励: "Recibir premio",
  新人豪礼: "Recién llegado",
  "参与人数：": "El número de participantes:",
  条件: "Condición",
  入金量: "Depósito",
  完成: "Finalizar",
  任务奖励: "Recompensas de la misión",
  距任务更新: "Actualizar desde la tarea",
  "条件：": "Condición:",
  活动规则: "regla de actividad",
  奖励明细: "Detalles de la recompensa",
  已获得: "Obtenido",
  交易奖励: "Recompensa de transacción",
  Win奖励: "Gana recompensas",
  已领取: "Recibió",
  亏损金额超过: "El monto de la pérdida excede",
  单笔开仓金额超过: "La cantidad de una sola posición abierta excede",
  交易量: "Comercio",
  待完成: "Pendiente",
  入金: "Depósito",
  盈利金额超过: "El monto de la ganancia excede",
  开仓金额: "Monto",
  开仓金: "Posición abierta",
  盈利: "Lucro",
  亏损: "pérdida",
  领取: "Recibir",
  未领取: "no aclimatado",
  待领取: "Pendiente",
  再交易: "reintercambio",
  即可获得: "Llegar",
  领取成功: "Recibido con éxito",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Todas las actividades se contarán de acuerdo con la última hora de la actividad, y el ingreso no será válido después del vencimiento.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Los ingresos obtenidos se distribuirán en su cuenta de recompensas, y usted podrá canjearlos y retirarlos en cualquier momento según sus necesidades.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. El tipo de moneda de recompensa obtenida se emitirá de acuerdo con el tipo de tarea.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. El derecho de interpretación final pertenece a la plataforma. Si se descubre que hay medios anormales para arbitrar la bonificación de tareas de la plataforma, la plataforma tiene derecho a congelar y borrar los ingresos que haya obtenido.",
  成长学院: "Ayuda",
  "区块链 & 加密货币": "Cadena de bloques y criptomoneda",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Su guía integral para las criptomonedas, lo llevamos por el camino de las criptomonedas.",
  "全仓合约定单的全部保证金。":
    "El margen completo para una orden de futuros cruzados.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (P&L no realizadas - tarifa de manejo - tarifa nocturna) = nuevo valor / margen usado * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    'El P&L no realizado afectará directamente el "margen disponible". Cuando las ganancias y pérdidas no realizadas aumentan, el margen disponible aumentará, y las ganancias y pérdidas no realizadas aumentarán, y el margen disponible también disminuirá.',
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (margen utilizado) + (P&L no realizadas - tarifa de manejo - tarifa nocturna)",
  "注:可继续用于开仓的保证金。":
    "Nota: Margen que puede seguir utilizándose para abrir posiciones.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (P&L no realizadas - tarifa de manejo - tarifa nocturna)",
  "注:当前的资金结余。": "Nota: Saldo actual del fondo.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Se refiere al saldo total de la cuenta de futuros, incluido el saldo no disponible.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Nota: Cuanto mayor sea la tasa de riesgo, menor será el riesgo, y cuanto menor sea la tasa de riesgo, mayor será este valor.",
  该功能尚未开发: "Esta característica no ha sido desarrollada.",
  重置密码: "Restablecer la contraseña",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Ingrese de 8 a 20 caracteres, debe contener letras, números y caracteres especiales",
  修改成功: "Modificado con éxito",
  输入验证码: "Código",
  输入密码: "Clave",
  详情说明: "Detalles",
  已售罄: "Vendido",
  剩余期限: "Plazo",
  限期: "Plazo",
  闪兑货币选择: "Selección de moneda flash",
  地区选择: "Selección de región",
  "搜索国家/地区": "Buscar país",
  "身份信息已提交，将在*小时内审核完成":
    "La información de identidad ha sido enviada y será revisada dentro de {0} horas",
  "选择国家/地区": "Seleccionar país",
  "止盈价格需高于*": "El precio Take Profit debe ser superior a {0}",
  "止损价格需低于*": "El precio de stop loss debe ser inferior a {0}",
  "止盈价格需低于*": "El precio Take Profit debe ser inferior a {0}",
  "止损价格需高于*": "El precio de stop loss debe ser superior a {0}",
  教程详情: "Detalles del tutorial",
  请输入止损价: "Introduzca un precio de stop loss",
  活期: "Flexible",
  赎回后立即到账: "Retirar",
  赎回: "Redención",
  赎回理财: "Redención",
  是否赎回当前的理财订单:
    "Ya sea para canjear la orden de gestión de patrimonio actual",
  维护: "Mantenimiento",
  "系统正在维护中……": "El sistema está en mantenimiento...",
  合约: "Futuros",
  闪电兑换: "Canjear",
  流水挖矿: "Minería en la nube",
  邀请豪礼: "Invitación",
  计算器: "Calculadora",
  最新价: "Ultimo precio",
  涨跌幅: "Cambio",
  关注币种添加自选: "Sigue la moneda",
  一键添加自选: "Agregar",
  全标已读: "Lee todo",
  无消息: "No hay noticias",
  "暂时还没有收到任何消息通知哦!": "¡Ningún mensaje recibido!",
  没有更多数据: "No más",
  闪兑: "Intercambio",
  从: "De",
  "可用余额：": "Balance:",
  至: "Llegar",
  预览兑换结果: "Avance",
  闪兑规则: "Normas",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "El intercambio flash del mercado puede cambiar, consulte la cantidad real recibida.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "El tipo de cambio lo fija un tercero. Debido a los costos de cambio y las fluctuaciones del mercado, el tipo de cambio que intercambie puede ser más alto que el tipo de cambio del mercado. Por favor confirme cuidadosamente antes de proceder.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "La plataforma cobra una tarifa de manejo de aproximadamente {fee}% por cada intercambio, que se utiliza para el costo del intercambio en el intercambio.",
  确认汇兑: "Confirmar",
  您预估得到: "Estimacion",
  汇兑: "Canjear",
  汇兑比例: "Proporción",
  刷新: "Actualizar",
  兑换: "Canjear",
  没有更多了: "No más",
  搜索币种: "Búsqueda",
  可用: "Disponible",
  我知道了: "Saber",
  最新价格: "Último precio",
  确认: "Confirmar",
  最大: "máx.",
  "风险率(%)": "Riesgo(%)",
  持仓: "Posición",
  当前委托: "Ordenar",
  合作交易历史记录: "Historia",
  重置: "Reiniciar",
  余额: "Balance",
  现货账户: "Cuenta de fondos",
  合约账户: "Futuros",
  WIN账户: "Victoria",
  赏金账户: "Regalo",
  总资产折合: "Equivalente de activo",
  今日收益: "de hoy",
  充币: "Depósito",
  提币: "Retirar",
  账户权益: "Patrimonio de la cuenta",
  "数量/类别": "Cantidad/Tipo",
  全部币种: "Todas las monedas",
  全部类型: "Todos los tipos",
  账单信息: "Moneda",
  理财赎回: "Redención financiera",
  购买理财: "compra financiera",
  收入: "Ingreso",
  支出: "gastos",
  到: "llegar",
  资产划转: "Transferir",
  "最少*": "Mín*",
  "可用资产：": "Balance",
  确认划转: "Transferir",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Las transacciones solo se pueden realizar mediante la transferencia de activos a la cuenta correspondiente, y no se cobrará ninguna tarifa de manejo por transferencias entre cuentas.",
  币种账户选择: "elección de cuenta",
  选择账户: "elección de cuenta",
  划转详情: "Transferir información",
  划转明细: "Transferir información",
  收入账单: "información de ingresos",
  支出账单: "Información de gastos",
  金额: "Monto",
  总收益: "Total",
  佣金: "Otorgar",
  用户名: "nombre de usuario",
  "已领取：": "Recibió:",
  "未领取：": "No recibido:",
  "请选择国家/地区": "Por favor seleccione país/región",
  请上传身份信息: "Por favor cargue la identificación",
  请选择证件类型: "Seleccione el tipo de documento",
  请填写证件编码: "Por favor complete el número de identificación",
  请填写名字: "Por favor complete el nombre",
  请填写姓氏: "Por favor ingrese apellido",
  单向持仓: "sujeción unidireccional",
  投资金额: "Monto",
  天: "día",
  请输入手机号: "Teléfono",
  搜索: "Búsqueda",
  搜索历史: "Buscar Historia",
  热门推荐: "Caliente",
  "《Xspace Earn协议》": "《Protocolo de ganancias de Xspace》",
  我已了解并同意: "entiendo y estoy de acuerdo",
  协议: "protocolo",
  Xspace官方中文交流群: "Grupo oficial chino Xspace",
  Xspace官方英文交流群: "Grupo oficial de inglés de Xspace",
  预计维护至: "Esperaba que",
  更多功能: "Más",
  下载APP: "Descargar",
  理财: "Financiero",
  推荐: "Recomendar",
  Telegram官方中文频道: "Canal chino oficial de Telegram",
  Telegram官方英文频道: "Canal oficial en inglés de Telegram",
  官方邮箱: "correo electrónico oficial",
  客服邮箱: "Correo electrónico de atención al cliente",
  上述信息最终解释权归官方所有:
    "El derecho de interpretación final pertenece al funcionario",
  IOS版下载: "Descargar para IOS",
  Android版下载: "Descargar para Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Comisión = Comisión de compra + Comisión de fondos + Comisión de venta",
  资金划转: "Transferir",
  止盈: "TP",
  止损: "SL",
  自动平仓: "Cierre automático",
  委托挂单: "Orden pendiente encomendada",
  买: "Comprar",
  卖: "Vender",
  "买入/做多": "Comprar/Largo",
  "卖出/做空": "Vender corto",
  详情: "Detalles",
  浮动涨跌: "Altibajos",
  最小: "Mín",
  充币数量: "Monto de recarga",
  请输入充币数量: "Monto de recarga",
  支付截图: "Captura de pantalla de pago",
  提交: "Enviar",
  上传驾驶证: "Subir licencia de conducir",
  上传护照: "Subir pasaporte",
  加载中: "Cargando",
  上传成功: "Éxito",
  充值历史: "Historia",
  合约卖出手续费: "Tarifa del contrato",
  合约买入手续费: "Tarifa del contrato",
  系统加款: "Complemento del sistema",
  系统减款: "Reducción del sistema",
  合约资金费率: "Tasa de contrato",
  佣金分成: "Comisión",
  U本位合约: "Contrato",
  资产管理: "Activos",
  APP下载: "descarga de la aplicación",
  全球领先的数字理财平台:
    "La plataforma de gestión de riqueza digital líder en el mundo",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Comercia instantáneamente con cientos de activos digitales como Bitcoin y Ethereum",
  "24H涨跌幅": "Cambio 24H",
  查看更多行情: "Ver más cotizaciones",
  近24小时成交量: "Volumen en las últimas 24 horas",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Proporcione cientos de pares comerciales de divisas y contratos para satisfacer las necesidades comerciales diversificadas. La plataforma tiene más de 20 millones de usuarios en 200 países y regiones, y es la plataforma de servicios de activos digitales líder en el mundo.",
  用户国家分布: "Distribución del país del usuario",
  用户数: "Número de usuario",
  交易对: "par comercial",
  服务支持: "Servicio de ayuda",
  "随时随地，多平台终端交易":
    "En cualquier momento, en cualquier lugar, transacciones de terminales multiplataforma",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "El terminal múltiple es perfectamente compatible y puede satisfacer las necesidades de transacción de varios escenarios en cualquier momento.",
  随时查看实时行情: "Ver cotizaciones en tiempo real en cualquier momento",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Compre y venda fácilmente BTC, ETH, DOGE y otros activos digitales",
  获取您关注的加密货币价格变化预警:
    "Reciba alertas sobre los cambios en los precios de las criptomonedas que le interesan",
  "查看比特币现货、期货、期权价格":
    "Ver Bitcoin spot, futuros, precios de opciones",
  比较各交易所加密货币价格:
    "Compare los precios de las criptomonedas en los intercambios",
  开启您的数字货币之旅: "Comience su viaje de moneda digital",
  快捷购买数字货币: "Compra rápidamente moneda digital",
  "使用多种支付方式交易数字货币，安全快捷":
    "Utilice una variedad de métodos de pago para operar con moneda digital, de manera segura y rápida",
  最优的交易费率: "mejor tasa de transacción",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Tarifas de transacción preferenciales, derechos VIP competitivos, disfrute de un servicio de la mejor calidad",
  可信赖的安全保障: "Seguridad confiable",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Nuestras sofisticadas medidas de seguridad y fondos SAFU protegen sus activos digitales de todos los riesgos.",
  交易: "Comercio",
  币币市场: "Mercado de divisas",
  "24H成交量": "Volumen 24H",
  交易所: "Intercambio",
  "24H最高": "24H alto",
  "24H最低": "24 horas bajo",
  永续合约: "contrato perpetuo",
  日涨跌: "Cambio",
  交易深度: "profundidad de la transacción",
  "资产(合约)": "Activos (Contratos)",
  历史仓位: "Histórico",
  兑换记录: "Registro de intercambio",
  类型: "Escribe",
  充值记录: "Registro de recarga",
  划转记录: "Registro de transferencia",
  类别: "Categoría",
  历史账单: "Histórico",
  在线充值: "Recargar",
  安全设置: "Configuraciones de seguridad",
  用于账户登录使用: "Para uso de inicio de sesión de cuenta",
  用户提现时安全验证使用:
    "Verificación de seguridad y uso cuando los usuarios retiran efectivo",
  验证: "Verificar",
  万: "Diez mil",
  随时随地开启交易: "Comercio. En cualquier sitio.",
  "*货币交易所的所有功能尽在你的手中。":
    "Todas las funciones de cambio de moneda {0} están en tus manos.",
  "下载*货币交易所APP。": "Descarga la aplicación de cambio de moneda {0}.",
  下载自: "Descargar desde",
  内测版: "Beta cerrada",
  下载: "Descargar",
  扫码下载: "Escanear para descargar",
  设置您的资产密码: "Configure su contraseña de activo",
  法币: "Fiat",
  我要买: "Compra",
  我要卖: "Vender",
  请输入金额: "Por favor ingrese la cantidad",
  汇率: "Tipo de cambio",
  获得: "Obtener",
  支付通道: "Canal de pago",
  收款通道: "Canal de recogida",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Durante el proceso de venta, debe confirmar que su método de pago es suyo.",
  当前法币暂不支持交易对可尝试前往提现:
    "La moneda legal actual no admite el par comercial, puede intentar retirar",
  前往提现: "Ir a cobrar",
  该法币暂无通道: "Actualmente no hay ningún canal para esta moneda fiduciaria",
  "正在出售中，请耐心等待": "A la venta, por favor sea paciente",
  请选择支付通道: "Seleccione un canal de pago",
  请选择方式: "Seleccione un método",
  法币历史: "Historia fiduciaria",
  买币: "Comprar monedas",
  卖币: "Vender monedas",
  失败: "Fallar",
  已完成: "Terminado",
  未付款: "No pagado",
  待审核: "Revisión pendiente",
  打款中: "Pago",
  订单详情: "Detalles del pedido",
  联系客服: "Contactar Servicio al Cliente",
  到账金额: "Cantidad recibida",
  通道: "Pasillo",
  收款人: "Tenedor",
  收款账户: "Cuentas por cobrar",
  "订单出售失败，请查下方失败原因":
    "El pedido no se pudo vender, verifique el motivo de la falla a continuación",
  失败原因: "Motivo del fracaso",
  您还未进行付款: "No has hecho un pago",
  您已成功购买: "Has comprado con éxito",
  已取消订单: "Orden cancelada",
  "订单正在审核中，请耐心等待": "El pedido está en revisión, tenga paciencia.",
  您已成功出售: "Has vendido con éxito",
  "订单正在打款中，请耐心等待": "El pedido se está pagando, tenga paciencia.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "El proceso de pago requiere que vaya a otras plataformas para pagar los pedidos, preste atención a la seguridad de la información.",
  当前法币暂不支持交易对可尝试前往充值:
    "La moneda fiduciaria actual no admite pares comerciales, puede intentar recargar",
  前往充值: "Ir a recargar",
  购买: "Comprar",
  订单号: "Número de orden",
  单价: "Precio unitario",
  到账数量: "Cantidad a cuenta",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Actualmente hay pedidos pendientes de pago, ¿quieres continuar para iniciar un nuevo pedido de pago?",
  继续支付: "Seguir pagando",
  重新下单: "Reordenar",
  是否确定出售: "estas seguro de vender",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Una vez confirmada la venta, la plataforma se asignará al comprador, espere pacientemente a que la plataforma coincida.",
  出售: "Vender",
  收款方式: "Método de pago",
  订单已生成: "Se ha generado el pedido",
  取消订单: "Cancelar orden",
  请在: "Por favor en",
  内完成付款: "Completar el pago dentro",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Salga de la plataforma, inicie sesión en el pago que especificó, transfiera a la cuenta del vendedor a continuación y asegúrese de anotar en el pago:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Si no se realizan observaciones en el momento del pago, el vendedor no podrá confirmar el pago, lo que provocará la pérdida de activos que no se pueden recuperar.",
  "未在规定的时间内付款，订单都将被取消。":
    "Si no se realiza el pago en el tiempo estipulado, el pedido será cancelado.",
  姓名: "Nombre",
  收款姓名: "Nombre del beneficiario",
  开户支行: "Sucursal de apertura de cuenta",
  银行卡号: "Número de tarjeta bancaria",
  "付款后，返回本平台": "Después del pago, regrese a esta plataforma",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    'Asegúrese de hacer clic en el botón "He completado el pago, notificar al vendedor" a continuación',
  未点击卖家不会放款: "Si no hace clic, el vendedor no liberará el dinero",
  交易条款: "Términos de la transacción",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Al comprar la fuente de los fondos, debe tener fondos legales y seguros antes de poder operar",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "No se permiten fraudes, esquemas piramidales, apuestas u otras transacciones financieras ilegales.",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Después de que se complete la transacción, existe el riesgo de fondos, congelados o sospechosos de fraude, esquemas piramidales, fondos de juego, no entregaremos U al comprador y le daremos un reembolso",
  "已付款，通知卖家": "pagado, avisar al vendedor",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Si el comprador cancela {0} pedidos el mismo día, se cancelará la función de compra en el mismo día. ¿Está seguro de que desea cancelar este pedido?",
  添加收款方式: "Añade un metodo de pago",
  是否删除此收款方式: "Ya sea para eliminar este método de pago",
  删除: "Eliminar",
  请选择法币: "Seleccione moneda fiduciaria",
  机构名称: "Nombre de la Institución",
  请选择机构: "Por favor seleccione una institución",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Cuando venda moneda digital, el método de pago que seleccionó se mostrará al comprador, confirme que se haya completado correctamente.",
  请选择银行: "Seleccione un banco",
  请输入姓名: "Por favor escriba su nombre",
  账号: "Cuenta",
  请输入账号: "Por favor ingrese cuenta",
  收款码: "Código de recibo",
  "银行账号/卡号": "Número de cuenta bancaria/tarjeta",
  "请输入银行账号/卡号":
    "Por favor, introduzca el número de cuenta bancaria/tarjeta",
  "开户支行（选填）": "Sucursal de apertura de cuenta (opcional)",
  请输入开户支行: "Por favor ingrese la sucursal de apertura de cuenta",
  "加入*官方频道": "Únete {0} Canal oficial",
  关于: "Sobre",
  条款: "Términos",
  其他: "Otro",
  成功: "éxito",
  等待: "Espere",
  作废: "Vacío",
  确认付款: "Confirmar pago",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "¿Se ha realizado el pago? Si se confirma el pago, el comerciante confirmará si el pago se ha recibido en {0} minutos.",
  最大金额: "Cantidad máxima",
  最小金额: "Monto minimo",
  付款: "Pago",
  法币充值: "Recarga de moneda fiduciaria",
  法币提现: "Retiro fiduciario",
  待支付: "A pagar",
  已支付: "Pagado",
  商户名: "Comerciante",
  当前没有添加支付方式: "Actualmente no hay métodos de pago agregados",
  添加后再出售: "Añadir para vender",
  新人大礼包: "Regalo de recién llegado",
  注册即可领取: "Regístrese para recibir",
  立即领取: "Recibir",
  不再提示: "No volver a recordar",
  "该奖励需在APP中领取，请下载APP":
    "La recompensa debe recogerse en la APLICACIÓN, descargue la APLICACIÓN",
  去交易: "Comercio",
  期权交易: "Comercio de opciones",
  交易额: "Cantidad de transacción",
  可用额度: "Cuota disponible",
  交易周期: "Ciclo comercial",
  看涨: "Elevar",
  看跌: "Otoño",
  当前持有: "Tenencias actuales",
  胜率: "Ratio de victorias",
  "盈利/亏损数": "Pérdida de beneficios",
  累计实现盈亏: "Ganancias y pérdidas acumuladas",
  秒: "Segundos",
  分: "Minuto",
  小时: "Hora",
  天: "Días",
  周: "Semana",
  下单时间: "Tiempo de la orden",
  剩余时间: "Tiempo restante",
  买入价: "Precio de compra",
  结算价: "Precio acordado",
  实现盈利: "Lucro",
  结算时间: "Tiempo de liquidación",
  期权: "Opciones",
  新手教程: "Tutorial para principiantes",
  我的订单: "Ordenar",
  赔率: "Posibilidades",
  全部订单: "Todas las órdenes",
  持有订单: "Orden de espera",
  历史订单: "Historial de pedidos",
  输入交易额度: "Introduce la cantidad",
  选择交易周期: "Período de selección",
  去注册: "Registro",
  冻结: "Congelar",
  期权支出: "Pago de la opción",
  期权收入: "Renta de opciones",
  用户提现: "Retiro del usuario",
  "是否购买？": "¿Quieres comprar?",
  购买成功: "Compra exitosa",
  请签名: "Firma, por favor",
  提交签名: "Enviar firma",
  清空签名: "Firma clara",
  签名审核中: "Revisión de firma",
  已提交: "Presentada",
  扫一扫下载APP: "Escanea y descarga la aplicación",
  新手领取大礼包: "Los novatos reciben juerga",
  注册实名即送彩金: "Bono de registro y nombre real",
  交易总额: "Transacción total",
  资产不足: "Activos insuficientes",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "Los activos en la cuenta Win son insuficientes y se pueden transferir de la cuenta de fondos a esta cuenta",
  Win: "Win",
  在线充值: "Recarga en línea",
  比赛: "Concurso",
  未开始: "No empezado",
  赛程: "Calendario",
  赛果: "Resultado",
  已结束: "Sobre",
  让球: "Asian handicap",
  进球数: "Over/Under",
  大: "Over",
  小: "Under",
  胜负平: "Win/Lose",
  和局: "Juego dibujado",
  投注: "Apuesta",
  下注金额: "Monto de la apuesta",
  下注: "Apuesta",
  阵容: "Matriz de batalla",
  分析: "Analizar",
  输入下注金额: "Ingresar",
  下注成功: "Apuesta exitosa",
  投注记录: "Récord de apuestas",
  未结算: "Sin liquidación",
  已结算: "Establecido",
  流水: "Monto",
  输赢: "Ganar o perder",
  赛时: "Tiempo de juego",
  下注时间: "Tiempo de apuestas",
  足彩竞猜: "Prueba de fútbol",
  查看详情: "Controlar",
  输: "Perder",
  赢: "Victoria",
  主: "Equipo local",
  客: "Equipo de fuera",
  主胜: "El equipo de casa gana",
  客胜: "El equipo visitante gana",
  平: "Dibujado",
  已延期: "Pospuesto",
  账号异常: "Excepción de cuenta",
  全场独赢: "1x2",
  全场让球: "Handicap",
  全场大小: "Over/Under",
  总进球: "Goles totales",
  拍摄照片要求: "Requisitos de la foto",
  标准拍摄: "Disparo estándar",
  边框缺失: "Falta borde",
  照片模糊: "La foto esta borrosa",
  闪光强烈: "Destello fuerte",
  上传手持证件照: "Subir documentos de mano",
  上传证件照: "Subir foto de identificación",
  换一张: "Cambiar",
  出生日期: "Fecha de nacimiento",
  请选择出生日期: "Por favor, seleccione la fecha de nacimiento",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Después de ingresar la verificación gráfica correcta a continuación, obtenga el código de verificación de correo electrónico para registrarse",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Le quedan {0} certificaciones, después de lo cual no podrá continuar con la certificación",
  上半场: "Primera mitad",
  下半场: "Segunda mitad",
  独赢: "1x2",
  上半场独赢: "Primera mitad 1x2",
  下半场独赢: "Segunda mitad 1x2",
  上半场让球: "Primera mitad Handicap",
  下半场让球: "Segunda mitad Handicap",
  上半场大小球: "Primera mitad Over/Under",
  下半场大小球: "Segunda mitad Over/Under",
  波胆: "Correct Score",
  上半场波胆: "Primera mitad Correct Score",
  下半场波胆: "Segunda mitad Correct Score",
  单双: "Odd/Even",
  上半场单双: "Primera mitad Odd/Even",
  下半场单双: "Segunda mitad Odd/Even",
  总进球: "Total Goal",
  上半场总进球: "Primera mitad Total Goal",
  下半场总进球: "Segunda mitad Total Goal",
  单: "Odd",
  双: "Even",
  中场: "Centro del campo",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Nota: siga esta imagen de muestra para escribir texto en papel blanco y tome la foto con la tarjeta de identificación",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Recientemente, se ha descubierto una gran cantidad de cuentas fraudulentas y se han castigado varias cuentas ilegales. Si hay un error de juicio como una cuenta ilegal, comuníquese con el servicio al cliente en línea.",
  最小下注金额: "Cantidad mínima de apuesta",
  参与活动最小下注金额:
    "Cantidad mínima de apuesta para participar en el evento",
  记住密码: "Recordar contraseña",
  比分: "Puntaje",
  "您还未登录，请先登录": "Por favor Iniciar sesión",
  立即登录: "Acceso",
  下注限额: "Límite de apuestas",
  可赢金额: "Cantidad ganable",
  闪兑详情: "Detalles de destello",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Debido al tipo de cambio, habrá una diferencia entre el monto de la apuesta y el monto real de la apuesta, consulte el pedido.",
  开赛时间: "Hora de inicio",
  足球收入: "Ingresos de futbol",
  足球支出: "Gastos de futbol",
  活动详情: "Detalles de la actividad",
  为世界杯喝彩: "Saludos por la copa del mundo",
  我的竞猜: "Mi",
  "竞猜比赛、有机会瓜分*USDT":
    "Adivina el juego y ten la oportunidad de compartir {0}USDT",
  "瓜分*USDT": "Compartir {0}USDT",
  距离活动结束还有: "Fin de la distancia",
  我的门票: "Mi billete",
  竞猜结束时间: "Adivina la hora de finalización",
  猜比分: "Adivina la puntuación",
  "福利派送中，完成任务即可获取门票":
    "La distribución de bienestar está en progreso, complete la tarea para obtener boletos",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Complete las siguientes tareas, puede obtener la cantidad correspondiente de boletos para participar en la competencia",
  时: "Hora",
  活动: "Actividad",
  竞猜记录: "registro de adivinanzas",
  结果: "Resultado",
  任务: "Tarea",
  去邀请: "Invitar",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "La adivinación del marcador de cada partido, participar en la adivinación puede dividir la recompensa de ${0}.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Participar en el concurso requiere boletos, que se pueden obtener de acuerdo con las tareas de la plataforma.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "Después de que la suposición sea exitosa, envíe la captura de pantalla del resultado de la suposición al servicio de atención al cliente, y el servicio de atención al cliente transferirá el bono a su cuenta de fondos, y podrá retirarlo de inmediato.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Cualquier trampa está prohibida y las recompensas se anularán si se descubre una trampa.",
  "完成任务后，点击咨询客服获得门票。":
    "Después de completar la tarea, haga clic en Consultar servicio al cliente para obtener el ticket.",
  继续猜: "Continua adivinando",
  总单数: "Total singular",
  赛事筛选: "Proyección de eventos",
  球队筛选: "Selección de equipo",
  总金额: "Suma global",
  总流水: "Facturación total",
  派奖金额: "Monto del bono",
  下注单数: "Apuesta número impar",
  利润: "Lucro",
  更多福利: "Bienestar",
  我的奖金: "Mi bono",
  未认证: "No certificado",
  总量: "Total",
  或: "O",
  模拟交易: "Operaciones de demostración",
  体验账户不可操作: "La cuenta de experiencia no funciona",
  世界杯比分竞猜: "Adivina la puntuación",
  "领*USDT起": "Desde {0}USDT",
  消息: "Información",
  滚球: "Bola rodante",
  是: "Sí.",
  不是: "No, No.",
  当前余额: "saldo actual",
  KOL招募: "Reclutamiento de KOL",
  本月净输赢: "Ganancia/pérdida neta del mes",
  本月佣金: "comisión del mes",
  佣金比例: "porcentaje de comision",
  活跃人数: "número activo",
  新增下级: "Agregar subordinado",
  登录人数: "número de inicios de sesión",
  首存人数: "Número de primeros depositantes",
  数据分析: "análisis de los datos",
  人数: "número de personas",
  新注册存款金额: "Nuevo monto de depósito registrado",
  老用户存款金额: "Cantidad de depósito de usuario anterior",
  首存金额: "Monto del primer depósito",
  快捷入口: "Entrada rápida",
  成员管理: "gestión de miembros",
  财务报表: "Estados financieros",
  分红报表: "Informe de dividendos",
  订单记录: "registro de pedido",
  VIP专享: "Exclusivo VIP",
  推广工具: "herramienta de promoción",
  计算规则: "Reglas de cálculo",
  账变明细: "Detalles de cambio de cuenta",
  成员: "miembro",
  下级概览: "Resumen de subordinados",
  下级成员总计: "Miembros Subordinados Total",
  本月新增: "nuevo este mes",
  本月活跃会员: "Miembro activo del mes",
  今日活跃会员: "Miembros activos hoy",
  本月有效活跃: "activo este mes",
  活跃成员占比: "Proporción de Miembros Activos",
  本月活跃: "activo este mes",
  今日活跃: "activo hoy",
  下级成员: "Miembro Junior",
  会员账号: "cuenta de miembro",
  统计时间: "Estadísticas Tiempo",
  筛选: "filtrar",
  存款: "depósito",
  取款: "retirar dinero",
  总输赢: "ganancia o pérdida total",
  是否有效用户: "¿Es un usuario válido?",
  最近登录时间: "última hora de inicio de sesión",
  否: "no",
  开始时间: "Tiempo de empezar",
  结束时间: "Hora de finalización",
  提取: "extracto",
  总盈亏: "ganancias y pérdidas totales",
  净盈亏: "ganancia y pérdida neta",
  分红: "dividendos",
  概览: "visión de conjunto",
  月度详细数据: "Datos mensuales detallados",
  未发放: "no emitido",
  活跃用户: "usuario activo",
  有效新增会员: "Agregar nuevos miembros de manera efectiva",
  冲正后净输赢: "Ganancia o pérdida neta después del lavado",
  上月结余: "Saldo del último mes",
  净输赢: "ganancia/pérdida neta",
  "系统每日新加坡时间1:00更新一次报表":
    "El sistema actualiza el informe una vez al día a la 1: 00 hora de Singapur",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Los números positivos en los datos, las ganancias y pérdidas totales y las ganancias y pérdidas netas en el informe indican la ganancia del agente, y los números negativos indican la pérdida del agente.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Los datos de la comisión se actualizan todos los días y son solo de referencia, no el estándar de distribución de la comisión real.",
  选择时间: "período de selección",
  足球: "fútbol",
  投注金额: "monto de la apuesta",
  有效订单: "pedido válido",
  下级账户: "cuenta subordinada",
  待成交: "trato pendiente",
  下单金额: "Total de la orden",
  订单内容: "contenido del pedido",
  秒数: "segundos",
  联赛: "la Liga",
  队伍: "equipo",
  比赛时间: "tiempo de competencia",
  玩法: "cómo jugar",
  等级规则表: "Tabla de reglas de calificación",
  等级: "calificación",
  活跃会员: "miembro activo",
  最新活跃: "último activo",
  额外佣金: "comisión adicional",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "El estándar de crecimiento y el sistema de recompensas del nivel correspondiente se implementan cada mes, y solo se puede disfrutar de una recompensa de nivel.",
  渠道生成: "generación de canales",
  创建: "crear",
  渠道名称: "Nombre del Canal",
  注册人数: "número de inscritos",
  浏览人数: "Espectadores",
  构建状态: "estado de construcción",
  禁用: "discapacitado",
  启用: "habilitar",
  查看: "Controlar",
  创建渠道: "crear canal",
  创建成功: "creado con éxito",
  操作成功: "Operación exitosa",
  渠道详情: "Detalles del canal",
  邀请码: "Código de invitación",
  访问人数: "número de visitantes",
  渠道地址: "dirección del canal",
  我的福利: "mis beneficios",
  充值福利: "Beneficios de recarga",
  当前流水: "flujo de corriente",
  如何参与: "como participar",
  币种充值: "recarga de moneda",
  充值福利中领取福利: "Reciba beneficios de los beneficios de recarga",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Reglas: El beneficio de recarga es voluntario para recibir, y el período de validez es dentro de las 24 horas posteriores a la recarga. No será válido después de la fecha de vencimiento. Después de recibirlo, la función de retiro de efectivo se bloqueará temporalmente y el retiro de efectivo puede ser desbloqueado después de alcanzar la facturación.",
  失效日期: "fecha de caducidad",
  "暂无福利领取，充值后领取":
    "Aún no hay beneficios para recibir, recibir después de recargar",
  参与: "participar",
  充值赠送: "regalo de recarga",
  "领取*%的赠送": "Recibir {0}% de regalo",
  去领取: "para recoger",
  VIP奖励: "recompensas VIP",
  "当前可领取*USDT，是否确认领取":
    "Puede recibir {0}USDT en la actualidad, ¿confirma el reclamo?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Después de reclamar, la función de retiro se bloqueará temporalmente y el bloqueo se puede desbloquear cuando su facturación alcance {0} USDT",
  充值送大礼: "Recarga para obtener un gran regalo",
  "存入越多，送越多！": "¡Cuanto más deposite, más obtendrá!",
  无效: "inválido",
  有效: "eficiente",
  总存金额: "monto total del depósito",
  提示: "insinuación",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Los números positivos en ganancias y pérdidas totales y ganancias y pérdidas netas indican ganancias de la plataforma, y ​​los números negativos indican pérdidas. Los datos diarios son solo para referencia y no sirven como el estándar real de distribución de comisiones.",
  "净盈亏：总盈亏-用户返水":
    "Ganancias y pérdidas netas: ganancias y pérdidas totales - reembolso de usuario",
  盈利方: "fiesta rentable",
  代理: "interino",
  客户: "cliente",
  平局: "dibujar",
  平台: "plataforma",
  "已提交审核，请耐心等待": "Enviado para revisión, tenga paciencia",
  充值日期: "fecha de recarga",
  平台本月总输赢: "Ganancias y pérdidas totales de la plataforma este mes",
  KOL招募合作: "Cooperación de reclutamiento KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "La plataforma ya está abierta [Evento de reclutamiento de KOL], siempre que tenga una cuenta de redes sociales, puede disfrutar de una bonificación única con la plataforma para promocionar clientes y puede disfrutar de beneficios de por vida.",
  级别: "nivel",
  平台利润返佣: "Reembolso de ganancias de la plataforma",
  佣金案例: "caso de la comisión",
  交易项目: "artículo de transacción",
  "期权交易、合约交易、足球游戏":
    "Negociación de opciones, negociación de contratos, partidos de fútbol",
  报名方式: "formas de registro",
  点击KOL招募报名: "Haga clic en el registro de reclutamiento de KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Bienvenido a unirse a nuestro equipo, la plataforma lo apoya completamente para establecer su propio sistema de usuario y puede obtener la comisión más alta {0}, esperamos que se una.",
  输入联系方式: "Ingrese la información de contacto",
  最低活跃人数: "Número activo mínimo",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Por ejemplo: el número de usuarios activos este mes ≥ {0} y la ganancia o pérdida total de la plataforma este mes ≥ {1}USDT, perteneces al nivel {2}, puedes obtener {3}% de comisión.",
  比分竞猜: "Adivina el marcador",
  豪礼相赠: "Regalos de lujo",
  足球活动: "Actividad de futbol",
  圣诞节活动: "Actividades navideñas",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Usted participó en el evento, bloqueando temporalmente la función de retiro de efectivo, y también necesita el flujo de agua de {0} usdt para desbloquear.",
  剩余流水: "Agua corriente residual",
  助力足球: "Ayudar al fútbol",
  佣金累计: "Comisión total",
  有效投注: "Apuesta válida",
  今日: "Hoy",
  今日返水: "Reembolso hoy",
  VIP返水: "Reembolso VIP",
  返水记录: "Registro de reembolso",
  成员信息: "Información de miembro",
  基本信息: "Información básica",
  钱包余额: "Saldo de la billetera",
  投注信息: "Información de apuestas",
  返水: "Reembolso",
  总下注: "Apuesta total",
  今日输赢: "Ganar o perder hoy",
  下注动态: "Dinámica de apuestas",
  返水奖励: "Bono de reembolso",
  分红金额: "Monto del dividendo",
  返水支出: "Pago de reembolso",
  总返水: "Reembolso total",
  流水总额: "Facturación total",
  返水总额: "Reembolso total",
  返水详情: "Detalles del reembolso",
  日流水: "Agua diaria",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "La plataforma proporciona recompensas de reembolso adicionales en función de la facturación diaria de su subordinado, y las recompensas se distribuirán a la cuenta de recompensas a las 00:00 hora de Singapur todos los días.",
  "申请成功，等待审核": "La solicitud es exitosa, esperando revisión",
  "我出本金，盈利共分享": "Yo pago el principal y comparto las ganancias",
  最高分红: "mayor dividendo",
  投资大师比赛: "Concurso Máster de Inversión",
  "我出本金，你盈利": "Yo pago el capital, tu te beneficias",
  共分享: "compartido",
  最高分红可得: "Dividendos máximos disponibles",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Se acercan beneficios exclusivos para nuevos usuarios, ${0} gratis, puede invertir en cualquier proyecto en la plataforma después de recibirlo y puede retirarlo inmediatamente después de obtener una ganancia.",
  报名领取: "Regístrese para recibir",
  已领取: "recibió",
  审核驳回: "Reseña rechazada",
  驳回原因: "Motivo del rechazo",
  活动运行周期: "Ciclo de ejecución de la actividad",
  "申请成功后起至*天内完成超额收益。":
    "Después de que la solicitud sea exitosa, el exceso de ingresos se completará dentro de {0} días.",
  分红比: "relación de dividendos",
  "*日获得盈利后，可获得*%的收益额。":
    "Después de obtener ganancias en el día {0}, puede obtener {1}% de las ganancias.",
  参与条件: "Condiciones de participación",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Los usuarios de Rusia y Turquía no participaron.",
  计算项目: "artículo de cálculo",
  "合约、体育、期权": "Contratos, Deportes, Opciones",
  我的投资: "mi inversión",
  参与天数: "Días de participación",
  累计下注: "apuesta acumulativa",
  累计盈亏: "Pérdidas y ganancias acumuladas",
  预计可分红: "Se espera que pague dividendos",
  常见问题: "problema comun",
  什么是平台出资: "¿Qué es la financiación de la plataforma?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Según los usuarios de algunos países, la plataforma proporciona fondos gratuitos para que los usuarios inviertan en proyectos.",
  怎么获取平台出资的福利:
    "Cómo obtener los beneficios de la plataforma de contribución",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Solo necesita ser un usuario en un país designado, hacer clic en el botón de registro de arriba y {0} USDT se transferirá a la cuenta de recompensas en la cuenta actual después de que se complete la revisión de la plataforma, y ​​puede transferirlo a otras cuentas para la inversión.",
  什么是分红: "que es dividendo",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividendo significa que dentro de un período de tiempo específico, después de que el ingreso alcance el 100%, se puede distribuir el 50% del exceso de ingreso. Por ejemplo: para recibir fondos de 100 USDT, el monto de los ingresos es del 120 %.",
  "如何取得分红？": "¿Cómo obtener dividendos?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "El ciclo de actividad es una vez cada {0}día. Una vez finalizada la actividad, se calculará y los dividendos se distribuirán a la cuenta de recompensas después de cumplir con los requisitos de la actividad. Si no cumples con los requisitos de actividad, el sistema automáticamente liquidará tus ingresos y aportes a la plataforma.",
  活动规则: "Reglas de actividad",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Las cuentas participantes deben someterse a una verificación KYC y cada cuenta está limitada a un beneficio.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "El KYC de las cuentas participantes requiere que el país especificado participe, y otras regiones no están autorizadas para participar. Verifique si el país activo es consistente con su país.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Después de participar con éxito en la actividad, la cuenta bloqueará temporalmente su función de retiro y su función de retiro se liberará una vez que se complete la actividad.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Respete las reglas de actividad de la plataforma. Si encuentra trampas o explota las lagunas del sistema para obtener ganancias, la plataforma congelará todos los fondos en su cuenta durante mucho tiempo.",
  平台出资: "Inversión en plataforma",
  平台出资收回: "Recuperación de la inversión de la plataforma",
  投资大师奖励: "Premio Máster en Inversiones",
  请下载APP添加收款方式:
    "Descargue la aplicación para agregar un método de pago",
  请下载APP进行身份验证:
    "Descargue la aplicación para la verificación de identidad",
  请下载APP参与: "Descarga la APP para participar",
  技术指标: "Indicadores tecnicos",
  主图: "Imagen principal",
  副图: "Subimagen",
  新注册人数: "Nuevos registrantes",
  老用户存款人数: "Antiguos depósitos de usuarios",
  存款人数: "Número de depositantes",
  取款人数: "Número de retiros",
  投注人数: "Número de apostantes",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Excepto Indonesia, India, Bangladesh y los usuarios que no han participado.",
  市场动态: "Dinámica del mercado",
  外汇合约: "contrato de cambio de divisas",
  盈亏比: "ratio de pérdidas y ganancias",
  委托价: "Precio del pedido",
  可用余额: "Saldo disponible",
  持仓额: "Monto de la posición",
  强平价: "Fuerte paridad",
  修改: "Revisar",
  修改价位: "Modificar precio",
  外汇: "Forex",
  外汇账户: "cuenta de divisas",
  我的交易: "mi transacción",
  未设置: "no establecido",
  超出最大可设数值: "Supera el valor máximo configurable",
  超出最小可设数值: "Supera el valor mínimo configurable",
  止盈超出最小可设数值:
    "La toma de ganancias excede el valor mínimo configurable",
  止损超出最大可设数值: "El stop loss supera el valor máximo configurable",
  止盈超出最大可设数值:
    "La toma de ganancias excede el valor máximo configurable",
  止损超出最小可设数值: "El stop loss supera el valor mínimo configurable",
  挖矿: "Minería",
  交易账户: "cuenta de transacciones",
  买涨: "Comprar",
  买跌: "comprar o vender",
  请输入正确的银行卡信息:
    "Por favor ingrese la información correcta de la tarjeta bancaria",
  联系在线客服:
    "Póngase en contacto con el servicio de atención al cliente en línea",
  法币交易请联系在线客服:
    "Para transacciones en moneda legal, comuníquese con el servicio de atención al cliente en línea",
  提交订单: "Orden de envio",
  "支付过程如有疑问,请联系在线客服":
    "Si tiene alguna pregunta sobre el proceso de pago, comuníquese con el servicio de atención al cliente en línea.",
  彩金赠送: "Regalos de oro",
  在线客服: "Servicio en línea",
  最少投资: "inversión mínima",
  "提交时间:": "Tiempo de presentación:",
  提现拒绝: "Retiro rechazado",
  认证拒绝: "Autenticación rechazada",
  认证通过: "Certificación aprobada",
  请输入正确的交易额度: "Por favor ingrese el monto correcto de la transacción",
  最大下注金额: "Monto máximo de apuesta",
  手机号: "Número de teléfono",
  邮箱注册: "registro de email",
  手机号注册: "Registro de número de teléfono móvil",
  查询: "Preguntar",
  手机号登录: "Inicio de sesión con número de teléfono móvil",
  邮箱登录: "Iniciar sesión por correo electrónico",
  请输入数量: "Por favor ingrese la cantidad",
  可用数量: "cantidad disponible",
  钱包登录: "Inicio de sesión de billetera",
  请输入正确的邀请码: "Por favor ingresa el código de invitación correcto",
  "请输入邀请码(必填)":
    "Por favor ingresa el código de invitación (obligatorio)",
  输入正确的金额: "Ingrese la cantidad correcta",
  法币充值: "recargar con moneda nacional",
  卢比充值: "Recarga de rupias",
  请输入法币: "Por favor, ingrese moneda fiduciaria",
  请输入IFSC: "Por favor, ingrese IFSC",
  "银行编码(选填)": "Código del banco (opcional)",
  请输入银行编码: "Por favor, ingrese el código del banco",
  请输入大于8位数的密码: "Por favor ingrese una contraseña de más de 8 dígitos",
  添加成功: "Agregado exitosamente",
  "60秒": "60 segundos",
  "180秒": "180 segundos",
  "300秒": "300 segundos",
  "2次密码不一致": "2 contraseñas son inconsistentes",
  输入提币数量: "Ingrese el monto del retiro",
  图片格式不正确: "Formato de imagen incorrecto",
  图片大于20M: "La imagen supera los 20 MB",
  请设置委托价格: "Por favor, establezca el precio del encargo",
  输入资金密码: "Introduzca la contraseña de fondos",
  验证码错误: "Error del código de verificación",
  充值拒绝: "Recarga rechazada",
  请输入SSN: "Por favor ingrese el número de seguro social",
  合约交易: "comercio por contrato",
  结算完成: "Liquidación completada",
  继续下单: "Continuar ordenando",
  最低购买: "compra mínima",
  最高购买: "compra más alta",
  限价: "Precio Límite",
  买入价格: "Precio de Compra",
  买入量: "Cantidad de Compra",
  卖出价格: "Precio de Venta",
  卖出量: "Cantidad de Venta",
  买入: "Comprar",
  卖出: "Vender",
  订单创建成功: "Orden Creada con Éxito",
  币币买入支出: "Gasto de Compra de Cripto",
  币币买入支出退还: "Reembolso de Gasto de Compra de Cripto",
  币币买入获得: "Cripto Recibido en Compra",
  币币卖出支出: "Gasto de Venta de Cripto",
  币币卖出支出退还: "Reembolso de Gasto de Venta de Cripto",
  币币卖出获得: "Cripto Recibido en Venta",
  币币交易手续费: "Comisión de Transacción de Cripto",
  请输入限价: "Por Favor Ingrese el Precio Límite",
  成交: "Completado",
  等待成交: "Esperando Completarse",
  交易完成: "Transacción Completada",
  被取消: "Cancelado",
  交易时间: "Hora de la Transacción",

  法币交易: "Intercambio de moneda fiduciaria",
  法币出售: "Venta de moneda fiduciaria",
  两次密码不一致: "Las dos contraseñas no coinciden",
  再次输入账户密码: "Vuelve a ingresar la contraseña de la cuenta",

  美国: "Estados Unidos",
  韩国: "Corea del Sur",
  阿尔巴尼亚: "Albania",
  津巴布韦: "Zimbabue",
  赞比亚: "Zambia",
  也门: "Yemen",
  美属维尔京群岛: "Islas Vírgenes de EE.UU.",
  英属处女群岛: "Islas Vírgenes Británicas",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistán",
  乌拉圭: "Uruguay",
  英国: "Reino Unido",
  阿拉伯联合酋长国: "Emiratos Árabes Unidos",
  乌克兰: "Ucrania",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Islas Turcas y Caicos",
  土库曼斯坦: "Turkmenistán",
  土耳其: "Turquía",
  突尼斯: "Túnez",
  特立尼达和多巴哥: "Trinidad y Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Timor Oriental",
  泰国: "Tailandia",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tayikistán",
  中国台湾: "Taiwán (China)",
  叙利亚: "Siria",
  瑞士: "Suiza",
  瑞典: "Suecia",
  斯威士兰: "Esuatini",
  苏里南: "Surinam",
  苏丹: "Sudán",
  斯里兰卡: "Sri Lanka",
  西班牙: "España",
  南非: "Sudáfrica",
  索马里: "Somalia",
  所罗门群岛: "Islas Salomón",
  斯洛文尼亚: "Eslovenia",
  斯洛伐克: "Eslovaquia",
  "圣马丁岛（荷兰部分）": "Sint Maarten (parte neerlandesa)",
  新加坡: "Singapur",
  塞拉利昂: "Sierra Leona",
  塞舌尔: "Seychelles",
  塞尔维亚: "Serbia",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Arabia Saudita",
  圣多美和普林西比: "Santo Tomé y Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "San Cristóbal y Nieves",
  圣文森特和格林纳丁斯: "San Vicente y las Granadinas",
  圣彼埃尔和密克隆岛: "San Pedro y Miquelón",
  圣露西亚: "Santa Lucía",
  圣基茨和尼维斯: "San Cristóbal y Nieves",
  卢旺达: "Ruanda",
  俄罗斯: "Rusia",
  罗马尼亚: "Rumania",
  留尼汪: "Reunión",
  刚果共和国: "República del Congo",
  卡塔尔: "Catar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugal",
  波兰: "Polonia",
  菲律宾: "Filipinas",
  秘鲁: "Perú",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papúa Nueva Guinea",
  巴拿马: "Panamá",
  巴勒斯坦: "Palestina",
  帕劳: "Palaos",
  巴基斯坦: "Pakistán",
  阿曼: "Omán",
  挪威: "Noruega",
  尼日利亚: "Nigeria",
  尼日尔: "Níger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Nueva Zelanda",
  新喀里多尼亚: "Nueva Caledonia",
  荷属安德列斯群岛: "Antillas Neerlandesas",
  荷兰: "Países Bajos",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mozambique",
  摩洛哥: "Marruecos",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongolia",
  摩纳哥: "Mónaco",
  摩尔多瓦: "Moldavia",
  墨西哥: "México",
  马约特: "Mayotte",
  毛里求斯: "Mauricio",
  毛里塔尼亚: "Mauritania",
  马里亚纳群岛: "Islas Marianas",
  马提尼克: "Martinica",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldivas",
  马来西亚: "Malasia",
  马拉维: "Malaui",
  马达加斯加: "Madagascar",
  马其顿: "Macedonia del Norte",
  中国澳门: "Macao (China)",
  卢森堡: "Luxemburgo",
  立陶宛: "Lituania",
  列支敦士登: "Liechtenstein",
  利比亚: "Libia",
  利比里亚: "Liberia",
  莱索托: "Lesoto",
  黎巴嫩: "Líbano",
  拉脱维亚: "Letonia",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirguistán",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenia",
  哈萨克斯坦: "Kazajistán",
  约旦: "Jordania",
  日本: "Japón",
  牙买加: "Jamaica",
  象牙海岸: "Costa de Marfil",
  意大利: "Italia",
  以色列: "Israel",
  爱尔兰: "Irlanda",
  伊拉克: "Irak",
  伊朗: "Irán",
  印度尼西亚: "Indonesia",
  印度: "India",
  冰岛: "Islandia",
  匈牙利: "Hungría",
  中国香港: "Hong Kong (China)",
  洪都拉斯: "Honduras",
  海地: "Haití",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bisáu",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadalupe",
  格林纳达: "Granada",
  格陵兰岛: "Groenlandia",
  希腊: "Grecia",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Alemania",
  格鲁吉亚: "Georgia",
  冈比亚: "Gambia",
  加蓬: "Gabón",
  法属波利尼西亚: "Polinesia Francesa",
  法属圭亚那: "Guayana Francesa",
  法国: "Francia",
  芬兰: "Finlandia",
  斐济: "Fiyi",
  法罗群岛: "Islas Feroe",
  埃塞俄比亚: "Etiopía",
  爱沙尼亚: "Estonia",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Guinea Ecuatorial",
  萨尔瓦多: "El Salvador",
  埃及: "Egipto",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "República Dominicana",
  多米尼加: "Dominica",
  吉布提: "Yibuti",
  丹麦: "Dinamarca",
  捷克: "República Checa",
  塞浦路斯: "Chipre",
  库拉索: "Curazao",
  古巴: "Cuba",
  克罗地亚: "Croacia",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Costa de Marfil",
  库克群岛: "Islas Cook",
  科摩罗: "Comoras",
  哥伦比亚: "Colombia",
  智利: "Chile",
  乍得: "Chad",
  中非共和国: "República Centroafricana",
  佛得角: "Cabo Verde",
  开曼群岛: "Islas Caimán",
  开普: "Cabo",
  加拿大: "Canadá",
  喀麦隆: "Camerún",
  柬埔寨: "Camboya",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgaria",
  文莱: "Brunei",
  巴西: "Brasil",
  博茨瓦纳: "Botsuana",
  波斯尼亚和黑塞哥维那: "Bosnia y Herzegovina",
  玻利维亚: "Bolivia",
  不丹: "Bután",
  百慕大群岛: "Bermudas",
  贝宁: "Benín",
  伯利兹: "Belice",
  比利时: "Bélgica",
  白俄罗斯: "Bielorrusia",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladés",
  巴林: "Baréin",
  巴哈马: "Bahamas",
  阿塞拜疆: "Azerbaiyán",
  奥地利: "Austria",
  澳大利亚: "Australia",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenia",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigua y Barbuda",
  安圭拉: "Anguila",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Samoa Americana",
  阿尔及利亚: "Argelia",
  中国: "China",

  日收益: "Ganancia diaria",
  "30天预期收益": "Ganancia esperada en 30 días",
  英伟达高速矿机: "Minero de alta velocidad NVIDIA",
  去投资: "Ir a invertir",
  新币榜: "Lista de nuevas monedas",
  主题: "Tema",
  立即探索: "Explorar ahora",
  等您来: "Te esperamos",
  最新活动: "Últimas actividades",
  货币划转: "Transferencia de divisas",
  提现钱包: "Cartera de retiro",
  加密合约: "Contrato criptográfico",
  外汇期货: "Futuros de divisas",
  定期: "Plazo fijo",
  探索产品: "Explorar productos",
  稳健型: "Tipo conservador",
  高收益: "Alto rendimiento",
  期货账户: "Cuenta de futuros",
  时间线: "Línea de tiempo",
  收藏: "Favoritos",
  委托订单: "Orden de delegación",
  最新交易: "Últimas transacciones",
  深度图: "Gráfico de profundidad",
  标记价格: "Precio marcado",
  "24h最高价": "Precio máximo en 24h",
  "24h成交量": "Volumen de operaciones en 24h",
  "24h最低价": "Precio mínimo en 24h",
  "24h成交额": "Monto de operaciones en 24h",
  "价格(USDT)": "Precio (USDT)",
  "数量(ETH)": "Cantidad (ETH)",
  看空: "Posición corta",
  余额不足: "Saldo insuficiente",
  最低购买: "Compra mínima",
  最高购买: "Compra máxima",
  下单成功: "Orden realizada con éxito",
  平仓成功: "Cierre de posición exitoso",
  请输入正确的平仓数量:
    "Ingrese la cantidad correcta para el cierre de posición",
  加仓成功: "Aumento de posición exitoso",
  请输入正确的加仓金额: "Ingrese el monto correcto para el aumento de posición",
  收藏成功: "Agregado a favoritos con éxito",
  取消收藏成功: "Eliminado de favoritos con éxito",
  日收益率: "Tasa de rendimiento diario",
  轻松理财: "Gestión de patrimonio sencilla",
  立即申购: "Suscribir ahora",
  申购日期: "Fecha de suscripción",
  加密货币: "Moneda criptográfica",
  交割合约: "Contrato de entrega",
  最小投资: "Inversión mínima",
  委托: "Delegación",
  "当指数价格触达时，将会触发委托平仓":
    "Cuando se alcance el precio del índice, se activará el cierre de posición delegado",
  预计盈利: "Ganancia esperada",
  最大投资: "Inversión máxima",
  现货交易: "Trading de criptomonedas",
  输入交易金额: "Ingrese el monto de la transacción",
  "可用额度：": "Límite disponible:",
  提现货币: "Divisa de retiro",
  期货合约: "Contrato de futuros",
  加密币永续: "Perpetuo cripto",
  外汇永续: "Perpetuo Forex",
  期权账户: "Cuenta de opciones",
  夜间模式: "Modo nocturno",
  未结盈亏: "Ganancias y pérdidas no realizadas",
  超额收益: "Rendimiento excesivo",
  "安全策略，低买高卖": "Estrategia de seguridad, compra baja y venta alta",
  投资金额应为: "El monto de la inversión debe ser",
  总收益率: "Rendimiento total",
  赎回成功: "Rescate exitoso",
  快捷卖币: "Venta rápida",
  修改止盈止损: "Modificar TP/SL",
  白皮书: "Libro blanco",

  托管资金: "Fondos en custodia",
  托管中: "En custodia",
  预计日收益: "Ganancia diaria estimada",
  累计收益: "Ganancias acumuladas",
  周期: "Período",
  日收益: "Ganancia diaria",
  限额: "Límite",
  立即托管: "Depositar ahora",
  "已鎖定 請聯繫客服": "Bloqueado, por favor contacte con atención al cliente",
  产品列表: "Lista de productos",
  规则: "Reglas",
  创建订单: "Crear orden",
  产品名称: "Nombre del producto",
  托管周期: "Período de custodia",
  等级限制: "Restricción de nivel",
  托管金额: "Monto de custodia",
  限额: "Límite",
  余额: "Saldo",
  购买日: "Fecha de compra",
  起息日: "Fecha de inicio de intereses",
  派息时间: "Hora de distribución de ganancias",
  每天: "Diariamente",
  计息结束日: "Fecha de fin de intereses",
  每日收益: "Ganancia diaria",
  预计收益: "Ganancia estimada",
  "收益将自动发送至您的余额账户;":
    "Las ganancias se enviarán automáticamente a su cuenta de saldo;",
  "您的资金没有任何风险;": "Sus fondos no tienen ningún riesgo;",
  "365*24小时不断地工作;": "Funciona 24 horas al día, 365 días al año;",
  托管中: "En custodia",
  结束: "Finalizado",
  今日收益: "Ganancia de hoy",
  剩余周期: "Período restante",
  进行中: "En curso",
  已发放: "Pagado",
  信誉分: "Puntos de reputación",

  复制成功: "Copiado con éxito",
  VIP权益: "Beneficios VIP",
  旧密码: "Contraseña antigua",
  请输入旧密码: "Por favor, introduce la contraseña antigua",
  "忘记旧密码请联系客服重置。":
    "Si olvidaste tu contraseña antigua, ponte en contacto con el servicio de atención al cliente para restablecerla.",
  去升级: "Actualizar",
  描述: "Descripción",
  实际存款金额: "Monto real del depósito",
  升级礼金: "Bono de actualización",
  隔夜利息: "Interés nocturno (swap)",
  自动结算: "Liquidación automática",
  等级规则: "Reglas de nivel",
  "WEB3.0币持有数据收益": "Rendimiento de datos por tenencia de monedas WEB3.0",
  总生产: "Producción total",
  有效节点: "Nodos activos",
  参与人: "Participantes",
  用户收益: "Rendimiento del usuario",
  "流动性WEB3.0输出": "Salida de liquidez WEB3.0",
  总资产: "Activos totales",

  ETHAI持有数据收益: "Rendimiento de datos de tenencia de ETHAI",
  AI量化流动性: "Liquidez cuantitativa de IA",
  现货买入手续费: "Comisión de compra al contado",
  现货支出: "Gasto al contado",
  现货资金费率: "Tasa de financiación al contado",
  现货卖出手续费: "Comisión de venta al contado",
  现货收入: "Ingreso al contado",
  外汇合约支出: "Gasto de contrato de divisas",
  外汇合约买入手续费: "Comisión de compra de contrato de divisas",
  外汇合约资金费率: "Tasa de financiación de contrato de divisas",
  外汇合约卖出手续费: "Comisión de venta de contrato de divisas",
  外汇合约收入: "Ingreso de contrato de divisas",
  理财购买: "Compra de producto financiero",
  VIP理财日收益: "Rendimiento diario de producto financiero VIP",
  VIP理财隔夜利息: "Interés nocturno de producto financiero VIP",
  VIP本金返还: "Devolución de capital VIP",
  VIP彩金发放: "Distribución de bono VIP",
  VIP彩金抵扣: "Deducción de bono VIP",
  隔夜利息: "Interés nocturno",
  设置资产密码: "Establecer contraseña de activos",

  锁仓挖矿: "Minería con bloqueo",
  一站式理财服务: "Servicio financiero integral",
  产品: "Productos",
  客服中心: "Centro de atención al cliente",
  贷款: "Préstamos",
  挖矿赚不停: "Gana continuamente con la minería",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "La minería con bloqueo consiste en confiar USDT (USD:1USDT=1USD) a las máquinas de minería de alto rendimiento de la plataforma para obtener beneficios dentro del pool de minería.",
  产品优势: "Ventajas del producto",
  随存随取: "Depósito y retiro flexible",
  锁仓周期: "Período de bloqueo",
  每日下发: "Distribución diaria",
  随机空投: "Airdrop aleatorio",
  "100%资金安全保障": "100% garantía de seguridad de fondos",
  "100%节假日收益不间断": "100% ingresos continuos incluso en días festivos",
  成功锁仓后当天产出: "Generación de收益 el mismo día tras el bloqueo exitoso",
  关于违约金: "Sobre la penalización",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Si desea retirar el capital antes del vencimiento, se aplicará una penalización. Penalización = tasa de penalización × días restantes × monto bloqueado.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Ejemplo: La tasa de penalización de este producto de minería con bloqueo es del 5%, quedan 3 días para el vencimiento y el monto bloqueado es de 10000U (USDT/USD). La penalización = 5%×3×10000=1500U, por lo que el capital real devuelto es 15000U-1500U.",
  收益计算: "Cálculo de ganancias",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "La plataforma ofrece varios productos financieros de minería con bloqueo para que los usuarios elijan. El cálculo de ganancias es el siguiente, por ejemplo:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Si un usuario bloquea 10000U (USDT, USD) en la plataforma y elige un producto financiero de 7 días con un rendimiento diario del 0.7%~1.8% del monto bloqueado, el rendimiento diario será el siguiente:",
  "最低:10000Ux0.7%=70U;": "Mínimo: 10000U×0.7%=70U;",
  "最高:10000Ux1.8%=180U;": "Máximo: 10000U×1.8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Después de 7 días se pueden obtener ganancias de 490U~1260U. Los ingresos se distribuyen diariamente y el capital bloqueado se transfiere automáticamente a su cuenta al vencimiento.",
  正在托管的资金: "Fondos en custodia",
  签到: "Registro diario",
  锁仓订单: "Órdenes de bloqueo",
  预计今日收益: "Ganancias estimadas de hoy",
  累计收益: "Ganancias acumuladas",
  托管中的订单: "Órdenes en custodia",
  单笔最少: "Mínimo por orden",
  单笔最多: "Máximo por orden",
  日收益率: "Rendimiento diario",
  说明: "Descripción",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Las estadísticas se basan en GMT+8<br>2. Las ganancias diarias se calculan con todas las órdenes liquidadas entre 00:00-23:59 GMT+8 (hora local 00:00-23:59)<br>3. Las ganancias del día se distribuyen entre 00:00-00:10 GMT+8 del día siguiente.",
  知道了: "Entendido",
  锁仓: "Bloquear",
  派息时间: "Hora de distribución",
  每日: "Diario",
  托管资金: "Fondos en gestión",
  到期返回: "Devolución al vencimiento",
  提前赎回: "Retiro anticipado",
  预计收益: "Ganancia estimada",
  认购: "Suscripción",
  热门: "Popular",
  数字货币: "Criptomonedas",
  贵金属: "Metales preciosos",
  大宗商品: "Materias primas",
  持仓明细: "Detalles de posiciones",
  历史明细: "Historial",
  当前价: "Precio actual",
  "↑买涨": "↑ Comprar al alza",
  "↓买跌": "↓ Comprar a la baja",
  显示全部: "Mostrar todo",
  买入金额: "Monto de compra",
  方向: "Dirección",
  收益: "Ganancia",
  预期收益: "Ganancia esperada",
  估用保证金: "Margen estimado",
  确认下单: "Confirmar orden",
  锁定: "Bloqueado",
  账户总资产: "Activos totales de la cuenta",
  明细: "Detalles",
  今日收益: "Ganancia de hoy",
  仓位保证金: "Margen de posición",
  持有仓位: "Posiciones abiertas",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Monto bloqueado = suma de todas las órdenes de minería con bloqueo no finalizadas",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Las estadísticas se basan en GMT+8<br>2. Las ganancias diarias se calculan con todas las órdenes liquidadas entre 00:00-23:59 GMT+8 (hora local 00:00-23:59)",
  充值方式: "Método de depósito",
  银行汇款: "Transferencia bancaria",
  "银行汇款请联系客服进行操作!":
    "¡Contacte con atención al cliente para realizar la transferencia bancaria!",
  提款方式: "Método de retiro",
  "银行提款请联系客服进行操作!":
    "¡Contacte con atención al cliente para realizar el retiro bancario!",
  资金明细: "Detalles de fondos",
  提现记录: "Historial de retiros",
  拒绝: "Rechazado",
  通过: "Aprobado",
  拒绝原因: "Motivo de rechazo",

  消息公告: "Anuncios",
  订单: "Pedidos",
  个人中心: "Centro personal",
  "未到期赎回需支付一定的违约金!":
    "La cancelación anticipada requiere el pago de una penalización.",

  请输入区号: "Por favor, introduzca el código de área",
  "请选择国家/地区": "Por favor, seleccione un país/región",

  今日开盘: "Apertura de hoy",
  昨日收盘: "Cierre de ayer",
  实名认证即送: "Recibe inmediatamente tras la verificación de identidad",
  立即认证: "Verificar ahora",
  新用户礼包: "Paquete de bienvenida para nuevos usuarios",
  完成新人任务领取: "Completa las tareas de nuevo usuario para reclamarlo",
  认证: "Verificar",
  时间周期: "Periodo de tiempo",
  支付金额: "Importe del pago",
  已平仓: "Cerrado",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Paquete de bienvenida MGBX para nuevos usuarios: cada usuario puede recibir como máximo",
  我已经阅读并同意: "He leído y acepto",
  隐私政策: "Política de privacidad",

  放弃奖励离开: "Abandonar la recompensa y salir",
  继续注册: "Continuar con el registro",
  分钟: "Minutos",

  "请先勾选隐私政策!":
    "¡Por favor, consulta primero la Política de privacidad!",
  添加其他到自选: "Añadir otros a la lista de seguimiento",
  充值最高可得: "Recarga y obtén hasta 30.000 $.",

  请输入格式正确的手机号:
    "Por favor, introduzca un número de teléfono móvil válido.",
  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 西班牙语



// WEBPACK FOOTER //
// ./src/lang/es.js